
export const root = {
    background: 'transparent',
    color: '{text.color}',
    padding: '0.5rem',
    gap: '0.125rem',
    indent: '1rem',
    transitionDuration: '{transition.duration}'
};

export const node = {
    padding: '0.25rem 0.5rem',
    borderRadius: '{border.radius.sm}',
    hoverBackground: '{surface.hover}',
    selectedBackground: 'rgba(239, 70, 0, 0.1)',
    color: '{text.color}',
    hoverColor: '{text.color}',
    selectedColor: '{primary.color}',
    fontSize: '0.875rem',
    focusRing: {
        width: '0',
        style: 'none',
        color: 'transparent',
        offset: '0',
        shadow: 'none'
    },
    gap: '0.25rem'
};

export const nodeIcon = {
    color: '{text.secondary.color}',
    hoverColor: '{text.secondary.color}',
    selectedColor: '{text.color}'
};

export const nodeToggleButton = {
    borderRadius: '{border.radius.sm}',
    size: '1.75rem',
    hoverBackground: '{surface.hover}',
    selectedHoverBackground: 'transparent',
    color: '{text.secondary.color}',
    hoverColor: '{text.color}',
    selectedHoverColor: '{primary.color}',
    focusRing: {
        width: '0',
        style: 'none',
        color: 'transparent',
        offset: '0',
        shadow: 'none'
    }
};

export const loadingIcon = {
    size: '2rem'
};

export const filter = {
    margin: '0 0 0.5rem 0'
};

export const droppoint = {
    height: '2px',
    margin: '0',
    background: 'transparent',
    hoverBackground: '{primary.color}',
    activeBackground: '{primary.color}'
};

export const colorScheme = {
    light: {
        node: {
            selectedBackground: 'rgba(239, 70, 0, 0.2)',
            selectedColor: '{text.color}',
            selectedFontWeight: '500'
        }
    },
    dark: {
        node: {
            selectedBackground: 'rgba(239, 70, 0, 0.2)',
            selectedColor: '{text.color}',
            selectedFontWeight: '500'
        }
    }
};

export default {
    root,
    node,
    nodeIcon,
    nodeToggleButton,
    loadingIcon,
    filter,
    droppoint,
    colorScheme
};
